import { Fragment, ReactElement } from 'react';

import { ClaimFlowType } from 'types';

import { Button } from 'chime-ui/components/Button';
import { SmallTitle, StandardText } from 'chime-ui/components/Typography';

import useTransactionType from 'hooks/useTransactionType';

import ErrorGeneric from './Generic';

type ErrorContextualProps = {
  referralToken: string;
  error?: {
    error_id?: string;
    error_body?: string;
    error_header?: string;
  };
};

function ErrorContextual({
  referralToken,
  error = null,
}: ErrorContextualProps): ReactElement {
  const { claimType } = useTransactionType();
  const hideLogin = claimType === ClaimFlowType.receive;

  if (!error?.error_id) return <ErrorGeneric showLogin={!hideLogin} />;

  const CTAComponent = () =>
    error.error_id === 'claimed_from_expired_status' ? (
      <Button as="a" href={`${process.env.MARKETING_HOST}/r/${referralToken}`}>
        Join Chime
      </Button>
    ) : (
      <Button
        as="a"
        href="https://help.chime.com/hc/en-us/articles/23918862092567-How-can-I-troubleshoot-issues-with-claiming-Pay-Anyone-Transfers-if-I-m-not-a-Chime-member"
      >
        Get help
      </Button>
    );

  return (
    <ErrorGeneric showLogin={!hideLogin} cta={<CTAComponent />}>
      <SmallTitle>{error.error_header}</SmallTitle>
      {error.error_body.split('\n').map((text, index) => (
        <Fragment key={`error${index}`}>
          <StandardText>{text}</StandardText>
          <br />
        </Fragment>
      ))}
    </ErrorGeneric>
  );
}

export default ErrorContextual;
